import Vue from 'vue'
import axios from 'axios'
import { get, isNil } from 'lodash'
const webRequestClient =
    process.env.NODE_ENV !== 'test'
        ? axios.create({
            baseURL: process.env.VUE_APP_API_ENDPOINT,
            withCredentials: true
        })
        : null
if (process.env.NODE_ENV !== 'test') {
    webRequestClient.interceptors.request.use(
        request => {
            if (request.method === 'put' && request.url === '/audience_admin/wam_custom_segments/bulk_update/json') {
                const data = request.data
                for (const key in data) {
                    if (!(typeof data[key] === 'string' || data[key] instanceof File)) {
                        data[key] = JSON.stringify(data[key])
                    }
                    if (typeof data[key] === 'string') {
                        data[key] = data[key].replace(/./g, function(c) {
                            if (c.charCodeAt() > 126) {
                                const hex = c.codePointAt(0).toString(16)
                                return '\\u' + '0000'.substring(0, 4 - hex.length) + hex
                            } else {
                                return c
                            }
                        })
                    }
                }
                request.data = JSON.stringify(data)
            } else if (
                request.method !== 'get' &&
                request.method !== 'delete' &&
                !(request.url.match(/criteria\/statistic\.json$/) && request.data.version === 2)
                && !request.url.includes('/audience_admin/accounts/')
            ) {
                const data = new FormData()
                for (const param in request.data) {
                    data.append(
                        param,
                        typeof request.data[param] === 'string' || request.data[param] instanceof File
                            ? request.data[param]
                            : JSON.stringify(request.data[param])
                    )
                }
                request.data = data
            }
            return Vue.prototype.$keycloak
                .updateTokenBeforeRequest(request)
                .then(function(updatedRequest) {
                    updatedRequest.headers['X-Requested-With'] = 'XMLHttpRequest'
                    const acc = parseInt(window.location.pathname.match(/^\/([\d]+)*/)[1])
                    updatedRequest.headers['X-Weborama-Account_Id'] = acc
                    updatedRequest.headers['Content-Type'] = 'application/json;charset=UTF-8'
                    if (request.url.match(/wousdat\/strong_classifiers_families\/graph\//)) {
                        updatedRequest.responseType = 'arraybuffer'
                    }
                    return updatedRequest
                })
                .catch(function(error) {
                    throw error
                })
        },
        error => {
            return Promise.reject({
                requestErrorMessage: error,
                apiError: {
                    status: error.response.status,
                    message: error.response.data.message || error.response.data.error,
                    statusText: get(error, 'response.statusText', null)
                }
            })
        }
    )
    webRequestClient.interceptors.response.use(
        response => {
            if (response.status === 200 && response.data.status === 'active') {
                return response.data
            } else if (response.status === 200 && (response.data.status === 'pending' || response.data.status === 'processing')) {
                const resp = {
                    data: response.data,
                    status: 'NOT_READY'
                }
                return resp
            } else if (response.status === 200 && response.data.status === 'failed') {
                const resp = {
                    data: response.data,
                    status: 'KO'
                }
                return resp
            } else if (response.status === 200 || response.status === 201 || (response.config.method === 'put' && response.status === 202)) {
                return response.data
            } else if (response.status === 202 || response.status === 206) {
                const resp =
                    response.config.method !== 'delete' //on delete success, API response.status === 202
                        ? {
                            data: response.data,
                            status: 'NOT_READY'
                        }
                        : response.data
                return resp
            } else if (response.status === 200 && response.data.status === 'failed') {
                //-- dataEntry failed
                const resp = {
                    data: response.data,
                    status: 'KO'
                }
                return resp
            } else {
                //-- all other failures
                response = response.data
                response.status = 'KO'
                return response
            }
        },
        error => {
            const errorStatus = get(error, 'response.status', null)
            if (errorStatus === 401) {
                // @TODO: when keycloak is stable, update redirection
                //window.location.href = process.env.VUE_APP_PORTAL_URL + '/logout'
                return { status: errorStatus, message: get(error, 'response.data.message', null) }
            } else if (error.message === 'CANCELED_REQUEST') {
                return { status: error.message }
            } else {
                let message
                if (errorStatus >= 500) {
                    message = get(error, 'response.data.message', 'Service Unavailable')
                    //message = get(error, 'response.statusText', _message)
                } else {
                    let responseDataMessage = get(error, 'response.data.message', null)
                    if (isNil(responseDataMessage)) responseDataMessage = get(error, 'response.data.Message', null)
                    if (isNil(responseDataMessage)) responseDataMessage = get(error, 'response.data', null)
                    message = isNil(responseDataMessage) ? get(error, 'response.data.error', error.message) : responseDataMessage
                }
                return Promise.reject({
                    responseErrorMessage: error.message || error.Message,
                    apiError: {
                        status: errorStatus,
                        message,
                        statusText: get(error, 'response.statusText', null)
                    }
                })
            }
        }
    )
}

const builderService = axios.create({
    baseURL: process.env.VUE_APP_BUILDER_SERVICE_BASE_URL,
    // withCredentials: true
})
export default webRequestClient

export {
    builderService,
}
